export default {
	title: "No activity for this goal.",
	description: "Once you define and save your goal, we’ll track and display an aggregate feed of all activity on the goal and it’s KRs.",
};
